import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstToUpperinPhrase',
})
export class FirstToUpperinPhrasePipe implements PipeTransform {

  transform(phrase : string): string {
    return phrase ? phrase.charAt(0).toUpperCase() + phrase.substr(1).toLowerCase() : '';
  }

}
